<template>
  <section class="cw-p-3">
    <div class="cw-relative">
      <!-- Enter Your Address Input -->
      <div role="group">
        <label class="cw-font-semibold cw-text-sm"
          for="address-input">{{ $t('enabled-locations-map.enter-your-address') }}</label>
        <input id="address-input"
          :value="addressInputValue"
          type="text"
          class="cw-block cw-appearance-none cw-w-full cw-py-1 cw-px-2 cw-mb-1 cw-text-base cw-leading-normal cw-bg-white cw-text-gray-800 cw-border cw-border-gray-200 cw-rounded"
          placeholder="E.g. 825 Ann Street Fortitude Valley"
          aria-haspopup="true"
          :aria-expanded="searchResultsFeatures.length > 0"
          autocomplete="off"
          @input="handleAddressInput">
      </div>

      <!-- Address Suggestions -->
      <div v-show="showDropdown"
        ref="dropdown"
        class="cw-absolute cw-p-1 cw-bg-white cw-border cw-border-gray-200 cw-rounded cw-z-10 cw-shadow-md"
        aria-labelledby="address-input"
        @mouseleave="debounceCloseDropdown">
        <ul class="cw-flex cw-flex-col cw-pl-0 cw-mb-0">
          <li v-for="feature in searchResultsFeatures"
            :key="feature.id"
            class="cw-relative cw-block cw-p-0">
            <button type="button"
              class="cw-text-left cw-font-normal cw-whitespace-no-wrap cw-py-1 cw-px-2 cw-leading-tight cw-text-xs cw-text-blue-700 hover:cw-bg-gray-200 cw-w-full"
              @click="selectOrigin(feature)">
              {{ feature.place_name }}
            </button>
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>

<script>
import axios from 'axios'

export default {
  name: 'FindMyLocationInput',

  props: {
    mapboxConfig: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },

  data() {
    return {
      addressInputValue: '',
      searchResultsFeatures: [],
      debounceSearch: null,
      showDropdown: false,
      selectedOrigin: {},
    }
  },

  created() {
    this.debounceSearch = this.debounce(this.forwardGeocode, 500)
    this.debounceCloseDropdown = this.debounce(this.closeDropdown, 250)
  },

  methods: {
    debounce(func, delay, immediate) {
      let timerId
      return (...args) => {
        const boundFunc = func.bind(this, ...args)
        clearTimeout(timerId)
        if (immediate && !timerId) {
          boundFunc()
        }
        const calleeFunc = immediate
          ? () => {
            timerId = null
          }
          : boundFunc
        timerId = setTimeout(calleeFunc, delay)
      }
    },
    handleAddressInput(event) {
      this.addressInputValue = event.target.value
      this.debounceSearch()
    },
    async forwardGeocode() {
      const token = `access_token=${this.mapboxConfig.mapboxToken}`
      const params = `limit=5`
      const response = await axios(`https://api.mapbox.com/geocoding/v5/mapbox.places/${this.addressInputValue}.json?${token}&${params}`)
      if (response) {
        this.searchResultsFeatures = response.data.features || []
        this.showDropdown = true
      }
    },
    selectOrigin(feature) {
      this.showDropdown = false
      this.$emit('select', feature)
    },
    closeDropdown() {
      this.showDropdown = false
    },
    clearTextFilter() {
      this.addressInputValue = ''
    },
  },
}
</script>
